import useTranslation from 'next-translate/useTranslation'
import { FC, useState } from 'react'
import AngleRightIcon from '@rsuite/icons/ArrowRightLine'
import { Button } from 'rsuite'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import ArrowLink from '../../ArrowLink'
import HeartIcon from '../../Icons/SavedProducts/HeartIcon'
import ListIcon from '../../Icons/ListIcon'
import InviteIcon from '../../Icons/SavedProducts/InviteIcon'
import OrderListIcon from '../../Icons/SavedProducts/CatalogIcon'
import Carousel from '../../Layouts/Carousel'
import ShortcutCard from '../ShortcutCard'
import useIsOnMobile from '../../../services/useIsOnMobile'
import { ScreenSize } from '../../../utils/constants'

import styles from '../../../styles/BuyerPortal/AccountCardsCarousel.module.less'

const InviteUserModal = dynamic(() => import('./InviteUserModal'))

const AccountCardsCarousel: FC = () => {
  const { t } = useTranslation('buyerProfile')
  const [isInviteModalOpen, setInviteModalOpen] = useState(false)

  const { route } = useRouter()
  const isDesktopView = useIsOnMobile(ScreenSize.xl)

  const cardsData = [
    {
      title: t('Invite users'),
      icon: <InviteIcon />,
      description: t('Manage your purchases together with other organization members'),
      linkComponent: (
        <Button
          appearance="subtle"
          onClick={() => setInviteModalOpen(true)}
        >
          <span>{t('Invite user')}</span>
          <AngleRightIcon className="margin-left-spacer-half text-color-primary arrow-link-icon" />
        </Button>
      ),
    },
    {
      title: t('My catalogs'),
      route: '/my-catalogs',
      icon: <OrderListIcon className={styles['order-list-icon']} />,
      description: t('Create a catalog for your location, team to easily manage selected products'),
      linkComponent: <ArrowLink
        href="/my-catalogs"
        text={t('View catalogs')}
      />,
    },
    {
      title: t('My saved products'),
      route: '/my-products',
      icon: <HeartIcon
        variant="dark"
        className={styles['heart-icon']}
      />,
      description: t('View and keep an inventory of your favourite products'),
      linkComponent: <ArrowLink
        href="/my-products"
        text={t('View saved products')}
      />,
    },
    {
      title: t('Order history'),
      route: '/my-orders',
      icon: <ListIcon />,
      description: t('View past orders, download order confirmations and reorder in one click'),
      linkComponent: <ArrowLink
        href="/my-orders"
        text={t('View order history')}
      />,
    },
  ].filter((card) => card.route !== route)

  const shouldHideArrows = cardsData.length < 4 && !isDesktopView

  return (
    <div className={styles['carousel-wrapper']}>
      <Carousel
        hideArrows={shouldHideArrows}
        hideArrowsFade={shouldHideArrows}
      >
        {cardsData.map((card) => (
          <ShortcutCard
            key={card.title}
            title={card.title}
            icon={card.icon}
            description={card.description}
            link={card.linkComponent}
          />
        ))}
      </Carousel>
      {isInviteModalOpen && (
        <InviteUserModal
          closeModal={() => setInviteModalOpen(false)}
        />
      )}
    </div>
  )
}

export default AccountCardsCarousel
